var scope_0 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2afe6655acc9bd07628bad253313c81a.js').default;
var scope_1 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/679c59ea1df07e2d0d1915ca8fa7fb78.js').default;
var scope_2 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b9ec35b8f6befadc13d0ab10e166393c.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    